const r = e => {
  var d, p;
  if (!((d = window.CryptoJS) != null && d.MD5) || !((p = window.CryptoJS) != null && p.SHA256)) {
    setTimeout(() => r(e), 2e3);
    return;
  }
  const i = n => window.CryptoJS.MD5(n != null ? n : "").toString(),
    l = n => window.CryptoJS.SHA256(n != null ? n : "").toString();
  window.dataLayer.push({
    session: {
      user: {
        userID: e.publicAccountId,
        loginType: e.loginType,
        md5_email: i(e == null ? void 0 : e.email),
        md5_gender: i(e == null ? void 0 : e.gender),
        md5_phone: i(e == null ? void 0 : e.phone),
        md5_zip_code: i(e == null ? void 0 : e.zipCode),
        sha256_email: l(e == null ? void 0 : e.email),
        sha256_gender: l(e == null ? void 0 : e.gender),
        sha256_phone: l(e == null ? void 0 : e.phone),
        sha256_zip_code: l(e == null ? void 0 : e.zipCode),
        account_type: e.company ? "profissional" : "privado",
        email_verified: e.emailVerified,
        phone_verified: e.phoneVerified
      }
    }
  });
};
export { r as onGetMe };